const objectToQueryString = (obj) =>
	Object.keys(obj)
		.map((key) => `${key}=${obj[key]}`)
		.join('&');

export const fireBuyItNowTaglessTracker = ({ adUnitCode, adObject, customTargeting = {} }) => {
	// Build BIN tracking ad unit path
	let iuParts = adUnitCode.split('/');
	iuParts[3] = 'bin_prebid';
	const iu = iuParts.join('/');

	// Combine for targeting with adinfo, ppid, and slot-specific UPR
	const targeting = {
		...customTargeting, // highestBid.adserverTargeting
		...(window.adInfo || {}),
		...(window.getUprTargeting?.(adObject) || {}), // slot-specific UPR
		ppid: window.globalAdConfig?.ppid,
	};

	const queryObj = {
		iu,
		sz: '1x1',
		c: Math.round(Date.now() / 1000),
		t: encodeURIComponent(objectToQueryString(targeting)),
		m: 'text/html',
	};

	const url = `https://securepubads.g.doubleclick.net/gampad/adx?${objectToQueryString(queryObj)}`;

	// Append hidden iframe to bottom of DOM
	const iframe = document.createElement('iframe');
	iframe.setAttribute('src', url);
	iframe.setAttribute('style', 'width:0;height:0;display:none');
	iframe.setAttribute('aria-hidden', 'true');
	iframe.id = `${adObject.adDivId}-bin-tracker`;
	document.body.appendChild(iframe);
};
